<template>
  <div>
    <div class="bg-black fixed top-0 right-0 w-full h-full" v-on:click="close" style="z-index:150;opacity:0.5;"></div>

    <div class="bg-white fixed top-0 right-0 h-full" style="width:400px;z-index:200;">

      <div class="bg-gray-200 border-b flex items-center justify-between p-4">
        <div class="text-base text-gray-800">
          Options for {{ broker.first_name }} {{ broker.last_name }}
        </div>

        <a href="#" 
          v-on:click.prevent="close"
          class="outline-none text-gray-600 text-xs hover:text-gray-700">
          <svg width="20" height="20" stroke-width="2" stroke="currentColor" fill="none">
            <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
          </svg>    
        </a>
      </div>

      <div class="px-4 py-2">

        <a href="#"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
          v-on:click.prevent="action('extend-trial')">Change Trial</a>

        <a href="#"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
          v-on:click.prevent="action('toggle-free-access')">
          <template v-if="broker.not_free_access">
            Grant free access to broker
          </template>
          <template v-else>
            Withdraw free access from broker
          </template>
        </a>

        <!-- <a href="#"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
          v-on:click.prevent="action('terminate-billing')">
          <template v-if="broker.recent_billing_date == null">No active billing agreement to terminate</template>
          <template v-else>Terminate billing agreement</template>
        </a> -->


        <a href="#"
          class="block no-underline p-3 font-semibold bg-blue-500 text-white hover:bg-blue-600 mt-2"
          v-on:click.prevent="action('suspend-broker')">
          <template v-if="broker.suspended">Un-suspended broker's access</template>
          <template v-else>Suspend broker's access</template>
        </a>

        <a href="#"
          class="block no-underline p-3 font-semibold bg-red-500 text-white hover:bg-red-600 mt-2"
          v-on:click.prevent="deleteBroker">Delete this broker</a>
      </div>
    </div>

    <ExtendTrialModal v-if="showModal" v-bind:brokerId="broker.id"></ExtendTrialModal>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus';
  import ExtendTrialModal from "./ExtendTrialModal";

  export default {

    props : {
      broker : {
        type    : Object,
        required: true
      }
    },

    components : {
      ExtendTrialModal
    },

    data() {
      return {
        showModal : false
      }
    },

    mounted() {
      EventBus.$on('close-extendtrial-modal', data => {
        this.showModal = false
      });
    },

    methods : {

      close() {
        EventBus.$emit('close-broker-actions');
      },

      action(act) {
        switch(act) {
          case 'extend-trial' :
             this.showModal = true;
          break;

          case 'toggle-free-access' :
             EventBus.$emit('toggle-free-access', this.broker);
          break;

          case 'terminate-billing' :
             if (this.broker.recent_billing_date == null) return;
             EventBus.$emit('terminate-billing', this.broker.id);
          break;

          case 'suspend-broker' :
             EventBus.$emit('suspend-broker', this.broker);
          break;
        }
      },

      deleteBroker() {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete broker - <b class='text-red-500'>" + (this.broker.first_name + ' ' + this.broker.last_name) + "</b>?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({}, 'broker/delete/' + this.broker.id, () => {
                this.close()
                this.$modal.hide('confirm-modal')
                EventBus.$emit('get-brokers')
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Broker deleted successfully"
                });
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    },
  }
</script>